<script>
import component from './base.vue';

export default component.extend({
  computed: {
    disableQaExpert: () => false,
  },
});
</script>
